import { FC } from 'react';

import { Document } from 'types';
import DocumentListLoader from '../../DocumentListLoader';

import DocumentsHeader from '../../BoardDocuments/DocumentsHeader';
import DocumentsList from '../../BoardDocuments/DocumentsList';

type BoardDetailsDocumentsCardBodyProps = {
  isAdmin: boolean;
  documents: Document[];
  documentsCount?: number;
  isLoadingDocuments?: boolean;
  onDownloadDocument: (index: number) => void; // eslint-disable-line
  onRemoveDocument: (index: number) => void; // eslint-disable-line
};

const BoardDetailsDocumentsCardBody: FC<BoardDetailsDocumentsCardBodyProps> = ({
  isAdmin,
  documents,
  documentsCount = 3,
  isLoadingDocuments = false,
  onDownloadDocument,
  onRemoveDocument,
}) => (
  <div className="card rounded-xl">
    <div className="nk-files nk-files-view-list">
      {isLoadingDocuments ? (
        <DocumentListLoader rows={documentsCount} height={45} />
      ) : (
        <>
          {documents?.length > 0 && (
            <DocumentsHeader isAdminView={isAdmin} hasDownload hasOptions />
          )}
          <DocumentsList
            documents={documents}
            hasOptions
            isAdminView={isAdmin}
            isSummaryVersion
            textSize={400}
            handleDownloadDocument={onDownloadDocument}
            handleRemoveDocument={onRemoveDocument}
          />
        </>
      )}
    </div>
  </div>
);

export default BoardDetailsDocumentsCardBody;
